import Vue from 'vue'
import simplebar from 'simplebar-vue'
import 'simplebar-core/dist/simplebar.css'

Vue.component('simplebar', simplebar)
